<template>
          <v-dialog v-model="show" persistent max-width="800px" color="white" :fullscreen="$vuetify.breakpoint.xs" scrollable>
              <v-card>
                <v-card-title class="headline primary--text fixNotchPaddingTop rundown-dialog-head">
                {{$t('PICTURE_POPUP_TITLE')}}
                </v-card-title>

                <v-card-text>
                            <v-row>

                                <v-col cols="12"> 
                                    <v-img :src="getPictureUrl" />
                                </v-col>
                            
                            <v-col cols="12">
                            <v-expansion-panels v-model="selectedSlot">
                                <v-expansion-panel>
                                <v-expansion-panel-header>{{$t('PICTURE_POPUP_UPLOAD')}}</v-expansion-panel-header>
                                <v-expansion-panel-content>
                                       <v-file-input
                                            :label="$t('PICTURE_POPUP_UPLOAD_PLACEHOLDER')"
                                            v-model="file" ref="file" 
                                            v-on:change="submitFile"
                                            prepend-icon="mdi-camera"
                                            v-bind:disabled="loading"
                                            accept="image/*"
                                        ></v-file-input>
                                </v-expansion-panel-content>
                                </v-expansion-panel>
 

                                <v-expansion-panel>
                                <v-expansion-panel-header>{{$t('PICTURE_POPUP_GALLERY')}}</v-expansion-panel-header>
                                <v-expansion-panel-content>
                            
                                                    <v-row>
                                                        <v-col cols="12" class="d-flex flex-wrap " >
                                                         
                                                                <v-col
                                                                v-for="n in 63"
                                                                :key="n"
                                                                class="d-flex child-flex pa-1" 
                                                                cols="12" md="6" lg="4"
                                                                >
                                                                <div flat tile >
                                                                    <v-img style="cursor:pointer;"
                                                                    :src="`img/rundown-sample-${n}.jpg`" 
                                                                    aspect-ratio="1.4"
                                                                    class="grey lighten-2"
                                                                    @click="selectPicture(`img/rundown-sample-${n}.jpg`)"
                                                                    >
                                                                    <template v-slot:placeholder>
                                                                        <v-row
                                                                        class="fill-height ma-0"
                                                                        align="center"
                                                                        justify="center"
                                                                        >
                                                                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                                                        </v-row>
                                                                    </template>
                                                                    </v-img>
                                                                </div>
                                                                </v-col>  
                                                        </v-col>
                                                    </v-row>
                                    

                                </v-expansion-panel-content>
                                </v-expansion-panel>


                            </v-expansion-panels>

                                </v-col>
                            </v-row>

                    </v-card-text>

            <v-divider></v-divider>

            <v-card-actions class="fixNotchPaddingBottom">
              <v-spacer></v-spacer>
              <v-btn color="primary rundown-dialog-btn" text @click="close()">{{$t('PICTURE_POPUP_CLOSE')}}</v-btn> 
 
             </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
 
  export default {
    name: 'RundownPictureDialog', 
    props: [],
    data(){
        return {  
             show: false,
             file: null,
             loading: false,
             callback: null,
             selectedSlot: 0,
             rundown: {
                 picture:null
             }
        }

    },  
    updated: function() {
        // fix for v-file-input not triggering properly

        setTimeout(() => {
            let inputs = document.querySelectorAll('.v-file-input input');
            [...inputs].forEach((input) => {
                input.remove()
            }) 
        }, 1000);
        
    },
    computed: {
    // a computed getter
    getPictureUrl: function () {
            return window.getAbsoluteUrl ? window.getAbsoluteUrl(this.rundown.picture) : this.rundown.picture;
        }
    },
    methods: {
        close()
        {
            this.show=false
            window.rundownApp.device.backButtonCallback = null;
        },
        // eslint-disable-next-line no-unused-vars
        showDialog(rundown, callback)
        {  
            this.callback=callback;
            this.rundown=rundown;
            this.show=true;
            this.file=null;
            window.rundownApp.device.backButtonCallback = this.close;
        }
        ,
        selectPicture(url)
        {
            if (this.callback)
                this.callback(url);

            this.close();
        },
          submitFile(){
            this.loading=true;
            let formData = new FormData();
            let me = this;
            formData.append('file', this.file?this.file:null);
            formData.append('rundownId',this.rundown.rundownId?this.rundown.rundownId:-1);
            formData.append('fileName',this.file?this.file.name:'');
            formData.append('mimeType',this.file?this.file.type:'');
            window.rundownApp.api.uploadRundownPicture(formData,
            function(res){
                    me.loading=false;
                    if (me.callback)
                        me.callback(res);

                    me.close();
/*
                    if(me.file!=null)
                        me.$emit('updated', {id:me.idDocumento, name:me.file.name});
                    else
                        me.$emit('updated', {id:me.idDocumento, name:null}); */
                }
            ,function(error){
                    me.loading=false;
                    me.$refs.file.errorMessages="Se ha producido un error al subir este documento.";
                    console.log(error);
                    me.file=null;
            });
      },
      },
  }
</script>